export const MONTHS = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
];

export const MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const monthLabel = (m, short = false) => {
    if (!m) return '';
    return (short ? MONTHS_SHORT : MONTHS)[m - 1] || '';
};

export const periodLabel = (m, y, short = true) => {
    if (!m || !y) return '—';
    return `${monthLabel(m, short)} ${y}`;
};

export const fmtMoney = (n, { showSign = false, currency = 'QAR', digits = 2 } = {}) => {
    const v = Number(n || 0);
    const sign = showSign && v > 0 ? '+' : '';
    const out = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    }).format(v);
    return `${sign}${currency ? currency + ' ' : ''}${out}`;
};

export const fmtMoneyCompact = (n) => {
    const v = Number(n || 0);
    const abs = Math.abs(v);
    if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(2)}M`;
    if (abs >= 1_000)     return `${(v / 1_000).toFixed(1)}K`;
    return v.toFixed(0);
};

export const fmtPct = (n, digits = 2) => {
    if (n === null || n === undefined || isNaN(n)) return '—';
    return `${Number(n).toFixed(digits)}%`;
};

export const fmtPp = (n, digits = 2) => {
    if (n === null || n === undefined || isNaN(n)) return '—';
    const v = Number(n);
    const sign = v > 0 ? '+' : '';
    return `${sign}${v.toFixed(digits)}pp`;
};

export const fmtDelta = (n, showSign = true) => {
    if (n === null || n === undefined || isNaN(n)) return '—';
    const v = Number(n);
    const sign = showSign && v > 0 ? '+' : '';
    return `${sign}${fmtMoney(v, { currency: '' }).trim()}`;
};

// Return CSS class indicating direction for a metric where "up = good" or "up = bad"
export const directionClass = (value, { upIsGood = true } = {}) => {
    if (value === 0 || value === null || value === undefined || isNaN(value)) return 'fr-neutral';
    const isPositive = value > 0;
    if (upIsGood) return isPositive ? 'fr-good' : 'fr-bad';
    return isPositive ? 'fr-bad' : 'fr-good';
};
